module.exports = __webpack_public_path__ + "static/media/face.0319ffff.obj";